const digest = 'f939aa3fff33eb73af267e5ba41b330b573dee642f708dea48c79a6832370286';
const css = `._signature_y54hg_1{max-height:4.5rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'signature': '_signature_y54hg_1' };
export const signature = '_signature_y54hg_1';
export { css, digest };